/** Created by azhou on 2019/3/25.*/
<template>
    <div>
      <public-title>
        {{queryCon.storeType | formatVar('StoreType')}}管理
        <el-button slot="right" @click="createSupplier" type="primary" class="ml-auto" v-if="queryCon.storeType<4">创建{{queryCon.storeType | formatVar('StoreType')}}</el-button>
      </public-title>
      <div class="load-area">
        <transition name="el-zoom-in-top" v-if="activeName === 'storeListSearch'">
          <search-con  class="mt-2" @getSearchCon="getSearchCon"/>
        </transition>
        <p v-if="AdminDataLists.total<=0 && activeName != 'roomTypeTrends'" class="mt-3">当前没有数据</p>
        <div v-else>
          <ul v-if="activeName != 'roomTypeTrends'" class="list-head mt-3">
            <template v-for="item in titleArr">
              <li  :class="item.class + (item.curso?' cursor-pointer':'')"  :key="item.name" v-if="activeName === 'storeListSearch'" @click="Sort(item.key)">
                {{item.name}}
                <img class="pasi" :src="'/images/public/sj-'+`${item.key==SortName?Sorts:0}`+'.png'" v-if="new Set(['积分','活跃值','注册时间','登录时间']).has(item.name)" >
              </li>
            </template>
            <template v-for="item in titleArr">
              <li  class="w-50"  :key="item" v-if="activeName != 'storeListSearch'" @click="Sort(item.key)">
                {{item.name}}
                <img class="pasi" :src="'/images/public/sj-'+`${item.key==SortName?Sorts:0}`+'.png'" v-if="new Set(['积分','活跃值','注册时间','登录时间']).has(item.name)" >
              </li>
            </template>
            <li class="w-1"></li>
          </ul>
          <div v-if="activeName === 'storeListSearch'" v-loading="loading" >
            <store-lists 
                         v-if="!loading"
                         :info="AdminDataLists.lists" 
                         @goStoreDetail="goStoreDetail" 
                         @editStore="editStore"
                         @getDataLists="getDataLists" 
                         />
          </div>
          <!--付款排行-->
          <div v-if="activeName === 'payList'">
            <pay-list v-for="item in AdminDataLists.lists" :key="item.id" :item="item"
                      @goStoreDetail="goStoreDetail" @goDetailList="goDetailList"/>
          </div>
          <!--积分排行-->
          <div v-if="activeName === 'creditList'">
            <credit-list v-for="item in AdminDataLists.lists" :key="item.id" :item="item"
                         @goStoreDetail="goStoreDetail" @goDetailList="goDetailList"/>
          </div>
          <!--移动推广-->
          <div v-if="activeName === 'roomTypeTrends'">
            <room-type :infoList="AdminDataLists.lists" @getState="getState" />
          </div>
          <el-pagination background layout="prev, pager, next" 
                          class="mt-4"
                          v-if="activeName !== 'roomTypeTrends'"
                          :page-size="20"
                          :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                          @current-change="$GFUN.pageChange"/>
          <div v-if="activeName === 'storeListSearch'" class="text-muted">共{{AdminDataLists.total}}条</div>
        </div>
      </div>
      <!--管理员创建门店-->
      <el-dialog title="创建门店" :visible.sync="showConfirmPanel" width="1300px" center id="loadConfirm">
          <!--酒店基础信息注册-->
          <h-reg-basic  v-if="queryCon.storeType==3" @saveInfo="saveBasicInfo"/>
           <!--采购商的注册基础信息-采购商注册填写企业信息-->
          <t-reg-basic  v-if="queryCon.storeType==2" @saveInfo="saveBasicInfo"/>
      </el-dialog>
      <!--创建成功弹窗-->
      <el-dialog title="提示" :visible.sync="showMailMsg" center :show-close="false" width="600px" top="28vh">
        <i class="el-icon-success success-icon"></i>
        <div class="create-success">门店创建成功</div>
        <div slot="footer">
          <el-button slot="footer" @click="showMailMsg = false">关 闭 </el-button>
          <el-button slot="footer" type="primary" @click="editStore(StoreID)">编辑企业</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  import StoreLists from './StoreLists'
  import PayList from  './PayList'
  import CreditList from './CreditList'
  import SearchCon from './SearchCon'
  import RoomType from './RoomType'
  import HRegBasic from '@/views/StoreInfo/BasicInfo/Comps/HRegBasic.vue'
  import TRegBasic from '@/views/StoreInfo/BasicInfo/Comps/TRegBasic.vue'
  export default {
    name: 'StoreManageIndex',
    components: { SearchCon, CreditList, PayList, StoreLists, RoomType,HRegBasic,TRegBasic},
    computed: {
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      tabArr() {
        switch (Number(this.queryCon.storeType)) {
          case 2: return [{name:'采购商列表',value:'storeListSearch'}];
          case 3: return [{name:'供应商列表',value:'storeListSearch'}];
          case 4: return [{name:'导游列表',value:'storeListSearch'}];
          default:return [];
        }
      },
      titleArr() {
        switch (this.activeName) {
          case 'storeListSearch':
            switch (Number(this.queryCon.storeType)) {
              case 2: return [{name:'采购商名称',class:'w-20'},{name:'企业账号',class:'w-20'},{name:'采购人数',class:'w-15'},{name:'前台/总机',class:'w-15'},{name:'区域',class:'w-20'},{name:'注册时间',class:'w-10',key:'time_order',curso:true},{name:'登录时间',class:'w-10',key:'exp_order',key:'login_update_time_order',curso:true},{name:'是否显示',class:'w-10'}];
              case 3: return [{name:'酒店名称',class:'w-20'},{name:'总房间数量',class:'w-10'},{name:'标间数量',class:'w-10'},{name:'企业账号',class:'w-10'},{name:'销售人数',class:'w-10'},{name:'星级',class:'w-10'},{name:'前台/总机',class:'w-15'},{name:'区域',class:'w-15'},{name:'活跃值',class:'w-10',key:'exp_order',curso:true},{name:'注册时间',class:'w-10',key:'time_order',curso:true},{name:'登录时间',class:'w-10',key:'exp_order',key:'login_update_time_order',curso:true},{name:'是否显示',class:'w-10'}];
              case 4: return [{name:'导游名称',class:'w-30'},{name:'手机号',class:'w-10'},{name:'身份证号',class:'w-10'},{name:'性别',class:'w-10'},{name:'导游级别',class:'w-10'},{name:'认证状态',class:'w-10'},{name:'显示状态',class:'w-10'},{name:'操作',class:'w-10'}];
              case 5:
              case 6:
              case 8: return ['门店名称','注册号码','负责人','地址','认证状态','显示状态','签约状态','微信','操作'];
              default:return [];
            }
          case 'payList':
            switch (Number(this.queryCon.storeType)) {
              case 4: return ['导游姓名','金额','操作'];
              default: return ['门店名称','金额','操作'];
            } 
          case 'creditList':
            switch (Number(this.queryCon.storeType)) {
              case 2: return ['采购商名称','积分','操作'];
              case 3:
              case 5:
              case 6:
              case 8: return ['门店名称','活跃值','活跃等级','等级图标','操作'];
              default:return [];
            }
          default: return []
        }
      }
    },
    watch:{
      'queryCon.storeType'() {
        this.activeName = 'storeListSearch'
        this.showSearch = false;  //收起搜索面板
        this.searchCon = {};      //清空搜索条件
        this.getDataLists();
      },
      'queryCon.page'() {
        this.getDataLists();
      }
    },
    created () {
      if (this.queryCon.back) this.activeName = 'roomTypeTrends'
    },
    mounted() { this.getDataLists();this.getState()},
    beforeDestroy() {
      this.UPDATECURRENTSTORE({type:''});
    },
    data() {
      return {
        activeName:'storeListSearch',
        showSearch:false,
        showConfirmPanel:false,
        searchCon:{},
        unread: 0,
        Sorts:0,
        AdminDataLists:{
          lists:[],
          total:0, 
        },
        loading: false,
        showMailMsg:false,
        StoreID:'',
        SortName:'',
      }
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE','UPDATESTOREBASIC']),
      ...mapActions(['POST_Admin_AddStore','POST_Admin_StoreList']),
      /*排序*/
      Sort(name){
        if(!name) return;
        if(name!=this.SortName){this.Sorts=0}
        if(this.Sorts!=2){
            this.Sorts++
        }else{
            this.Sorts=0
        }
        this.SortName=name;
        this.getDataLists()
      },
      //获取房型动态未推送数
      async getState () {
        // let res = await this.$axios.post('pc/Admin/getRoomStateStatus',{})
        // if (res.code === '00000') this.unread = res.info.status0
      },
      getDataLists() {
        this.loading = true;
        let data = {
          ...this.searchCon,
          [this.SortName]:this.Sorts,
          num:20,
          page:this.queryCon.page || 1,
          storeType:this.queryCon.storeType
        }
        this.POST_Admin_StoreList({data,successFun:(res)=>{
          this.AdminDataLists=res;
          this.loading = false;
        }});
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.queryCon.storeType,id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
      //编辑门店信息
      editStore(id) {
        if (!this.$GFUN.powerIsInArray([427,362,52,98])) { this._alert('您没有相关权限！',null,'error'); return; }
        let routeUrl = this.$router.resolve({name:'StoreBasicInfo',query:{type:this.queryCon.storeType,store:id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
      //查看支付明细和积分明细
      goDetailList(type,id,storeName) {
        let routeUrl = this.$router.resolve({
          name:'DetailList',
          query:{
            type,
            storeType:this.queryCon.storeType,
            storeId:id,
            storeName
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      //搜索门店条件
      getSearchCon(info) {
        this.searchCon = info;
        this.getDataLists();
      },
      //创建供应商
      createSupplier(){
      //清空当前门店信息
        this.showConfirmPanel=true;
        this.UPDATESTOREBASIC({})
      },
      /*保存用户基础信息*/
      saveBasicInfo(info,tabPosition) {
        this.POST_Admin_AddStore({
          data:info,
          type:this.queryCon.storeType,
          successFun: (res) => {
            console.log(res);
            this.StoreID=res.info.id;
            this.showConfirmPanel = false;
            this.showMailMsg= true;
            this.getDataLists();
          }})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .unread-msg {
      top: 0;
      left: 75px;
  }
  .pasi{
      width: 13px;
      cursor: pointer;
  }
  .w-1{
    width: 24px;
  }
  .load-area{
    min-height: 600px;
  }
  .create-success{
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  .success-icon{
    font-size: 56px;
    text-align: center;
    display:block;
    margin-bottom: 10px;
    color: #09af09;
  }
</style>
